import { cn } from '@core-utils/cn';
import { forwardRef } from 'react';

import styles from './Form.module.scss';

type FormDescriptionProps = React.HTMLAttributes<HTMLParagraphElement>;

const FormDescription = forwardRef<HTMLParagraphElement, FormDescriptionProps>(
    function FormDescription({ className, ...props }, ref) {
        return (
            <p
                ref={ref}
                className={cn(styles.FormDescription, className)}
                {...props}
            />
        );
    },
);

export { FormDescription };
